(() => {
  let attempts = 0;
  const placed = new WeakMap();
  const placeChat = () => {
    attempts++;
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot || chat?.shadowRoot;
    if (!root?.querySelector('.activator-nudge')) return attempts < 60;
    let sheet = placed.get(root);
    if (!sheet) {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(`:host{inset:0!important;width:100%!important;height:100%!important;contain:none!important;pointer-events:none!important}.activator-nudge{position:fixed!important;inset:auto 16px 16px auto!important;width:auto!important;height:auto!important;transform:none!important;pointer-events:auto!important}.activator-nudge .activator{position:relative!important;inset:auto!important;transform:none!important;margin:0!important;pointer-events:auto!important}@media(max-width:749px){.activator-nudge{inset:auto auto 12px 12px!important}}`);
      placed.set(root, sheet);
    }
    if (!root.adoptedStyleSheets.includes(sheet)) root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    return false;
  };
  placeChat();
  setInterval(placeChat, 500);
  document.addEventListener('click', (event) => {
    if (event.composedPath().some(el => el?.tagName === 'SHOPIFY-CHAT')) {
      requestAnimationFrame(placeChat);
      setTimeout(placeChat, 100);
    }
  });
})();
